module.exports['ar-eg'] = require('./ar-EG.js')
module.exports['en-us'] = require('./en-US.js')
module.exports['es-mx'] = require('./es-MX.js')
module.exports['ja-jp'] = require('./ja-JP.js')
module.exports['pt-br'] = require('./pt-BR.js')
module.exports['ru-ru'] = require('./ru-RU.js')
module.exports['zh-cn'] = require('./zh-CN.js')